export class SettingDomainState {
  public id: string[]
  public domain: string
  public lists: ISettingDomainData
  constructor() {
    this.id = []
    this.domain = ''
    this.lists = {
      column: [],
      result: [],
      itemCount: 0,
      page: 1,
      pageCount: 1,
      defaultFilter: {},
    }
  }
}

export interface ISettingDomainData {
  column: Array<{
    text: string,
    value: string,
    width: number,
    options: {
      orderable: boolean,
      filter: boolean,
      operation: string[],
    },
  }>,
  result: Array<{
    _id: string,
    name: string,
    status: string,
    userId: string,
    createdAt: number,
    updatedAt: number,
  }>,
  itemCount: number,
  page: number,
  pageCount: number,
  defaultFilter: {},
}

export default SettingDomainState
